module.exports = __webpack_public_path__ + "59510c6a32751af377b02a38c7859473.png";